import React from 'react';
import {useTranslation} from "react-i18next";
import {Text} from "../../../index";

const AiMeetingReviewStep = () => {
    const {t} = useTranslation();

    return (
        <div className="meeting-step">
            <Text size="f16" font="book" color="black">{t('review_step_title')}</Text>
            <ol>
                <li>
                    {t('review_step_text_1')}
                </li>
                <li>
                    {t('review_step_text_2')}
                </li>
                <li>
                    {t('review_step_text_3')}
                </li>
            </ol>
            <Text size="f16" font="book" color="black">{t('review_step_footer')}</Text>
        </div>
    );
};

export default AiMeetingReviewStep;